import { render, staticRenderFns } from "./DeptUserInfo.vue?vue&type=template&id=1b51ca48&scoped=true&"
import script from "./DeptUserInfo.vue?vue&type=script&lang=js&"
export * from "./DeptUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeptUserInfo.vue?vue&type=style&index=0&id=1b51ca48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b51ca48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b51ca48')) {
      api.createRecord('1b51ca48', component.options)
    } else {
      api.reload('1b51ca48', component.options)
    }
    module.hot.accept("./DeptUserInfo.vue?vue&type=template&id=1b51ca48&scoped=true&", function () {
      api.rerender('1b51ca48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/DeptUserInfo.vue"
export default component.exports